module.exports = __webpack_public_path__ + "static/media/047-dental.79f0b4c9.svg";